module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAS1BMVEUAAAClpaX///+lpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaUsgugaAAAAGHRSTlMAAAAyQENNYGKAiJygsMPLzNjg5u7w8vOD0ysqAAAAiUlEQVQ4y+2VRwrEMBAEp53knEP//6U+iIVVADNg8EV1U1EHSQyMiIb6pM9WAuUW6LOWiyETMEX0JWRbuPRcgZW9p1tSSAOXxsaNPWU/TIpT/F7cGZfBxoOnO1L2yJSPwBjRu1TL4TPnQD4HeqkED2R/6GLVNVQPVH1dmroUfxErFpBqtamWpoYbM3o/JSsd5P8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/submenu/icon_deskboard.png
// module id = 19
// module chunks = 0